import type { CartModifierItem } from "@/shared/cart/model.types"

/**
 * Resolved identity for a modifier row. Pricing and logs should key off `primary_key`
 * (bridge id) when present so rows stay stable across catalog child_menu_item_id changes.
 */
export type ResolvedModifierIdentity = {
  /** Prefer `modifier_group_item_id`; else fall back to `child_menu_item_id`. */
  primary_key: string
  modifier_group_item_id?: string
  child_menu_item_id: string
}

/**
 * Prefer `modifier_group_item_id` (addon / bridge / group row id) over `child_menu_item_id`
 * for correlation, validation, and stable keys. Both may be required downstream for API payloads.
 */
export function resolveModifierIdentity(
  mod: Pick<CartModifierItem, "modifier_group_item_id" | "child_menu_item_id">
): ResolvedModifierIdentity {
  const bridge = String(mod.modifier_group_item_id ?? "").trim()
  const child = String(mod.child_menu_item_id ?? "").trim()
  const primary_key = bridge || child
  return {
    primary_key,
    modifier_group_item_id: bridge || undefined,
    child_menu_item_id: child,
  }
}
